import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ThemeRenderer from "../ThemeRenderer";
import "./samplepage.css";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from "react-redux";
import { setNewTheme } from "../../../redux/reducers/profileSlice";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { snackbarContext } from "../../helpers/Snakbar";
const SamplePage = ({mode}) => {
  const setStateSnackbarContext = React.useContext(snackbarContext)
  const { userId } = useParams();
  const location = useLocation();
   const [utm, setUtmValues] = useState({
      utm_source: "unknown",
      utm_medium: "unknown",
      utm_campaign: null
    });
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const queryParams = new URLSearchParams(location.search);
  const themeId = queryParams.get("theme");

      const setTheme=()=>{
          dispatch(setNewTheme({themeId,navigate,setStateSnackbarContext}))
        }

          const isDashboard= mode === "private";

            useEffect(() => {
              const searchParams = new URLSearchParams(location.search);
          
              setUtmValues({
                utm_source: searchParams.get("utm_source")?.toLowerCase() || "unknown",
                utm_medium: searchParams.get("utm_medium")?.toLowerCase() || "unknown",
                utm_campaign: searchParams.get("utm_campaign")?.toLowerCase() || null
              });
            }, []); // 👈 EMPTY dependency = run once

  return (
    <div className="sample-page">

      {/* Floating close button */}
      <div
        className="sample-close-btn"
        onClick={() =>
          isDashboard
            ? navigate("/sample-themes")
            : window.location.href = "https://aamantraninvites.com/"
        }
      >
        <CloseIcon />
      </div>

      {/* Actual invite */}
      <ThemeRenderer
        demoId={userId}
        photoControls={true}
      />

      {/* Floating bottom button */}
    <button
  className="sample-use-btn"
  onClick={isDashboard ? setTheme : () => {
    window.location.href =
       `https://aamantran.link/free-trial?theme=${themeId}&utm_source=${utm.utm_source}&utm_medium=${utm.utm_medium}&utm_campaign=${utm.utm_campaign}`;
  }}
>
  {isDashboard ? "Use This Design" : "Try This Design"}

  <ArrowForwardIcon className="sample-use-btn-icon" />
</button>

    </div>
  );
};

export default SamplePage;